import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconBusinessCenter, IconLuggage } from '@travel-frontend/icons';
import { useTranslation } from 'next-i18next';
import { FlightDetailsBaggageInfo, FlightDetailsDescription } from '../../components/FlightDetails/index.js';
import { Container } from '../../components/FlightDetailsContent/components/Container.js';
import { Divider } from '../../components/FlightDetailsContent/components/Divider.js';
import { FlightRoute } from '../../components/FlightDetailsContent/components/FlightRoute.js';
import { InfoBoxes } from '../../components/FlightDetailsContent/components/InfoBoxes.js';
import { Title } from '../../components/FlightDetailsContent/components/Title.js';
import { useConvertFlightOverviewData } from '../../components/FlightDetailsContent/hooks/useConvertFlightOverviewData.js';
import { Paper, Stack } from '../../primitives/index.js';
export const FlightDetailsContent = ({
  flights: defaultFlights,
  flightsLuggage,
  flightsHandLuggage,
  supplierAgbLink,
  baggageInfoLink
}) => {
  const {
    t
  } = useTranslation('travelDetailsOverlay');
  const flights = useConvertFlightOverviewData(defaultFlights);
  const luggageWeight = flightsLuggage != null && flightsLuggage.weight > 0 ? flightsLuggage.weight : 0;
  const handLuggageWeight = flightsHandLuggage != null && flightsHandLuggage.weight > 0 ? flightsHandLuggage.weight : 0;
  const outboundFlights = flights.filter(f => f.direction === 'outbound');
  const inboundFlights = flights.filter(f => f.direction === 'inbound');
  return _jsxs(Container, {
    children: [_jsx(Title, {
      children: t('flightsTitle')
    }), _jsx(FlightRoute, {
      direction: "outbound",
      flights: outboundFlights
    }), _jsx(Divider, {}), _jsx(FlightRoute, {
      direction: "inbound",
      flights: inboundFlights
    }), _jsxs(InfoBoxes, {
      children: [_jsx(Paper, {
        children: _jsx(FlightDetailsDescription, {
          title: t('flightChanges'),
          linkTitle: t('flightChangesLink'),
          linkUrl: supplierAgbLink,
          children: _jsxs(Stack, {
            children: [_jsx("div", {
              children: t('flightChangesText.first')
            }), _jsx("div", {
              children: t('flightChangesText.second')
            })]
          })
        })
      }), _jsx(Paper, {
        children: _jsx(FlightDetailsBaggageInfo, {
          title: t('baggageInformation'),
          // @ts-expect-error TS(2322) FIXME: Type '[{ title: never; icon: Element; }, { title: ... Remove this comment to see the full error message
          items: [{
            title: t('handLuggage', {
              context: handLuggageWeight ? 'withWeigth' : 'withoutWeight',
              count: flightsHandLuggage ? 1 : 0,
              weight: handLuggageWeight
            }),
            icon: _jsx(IconBusinessCenter, {})
          }, {
            title: t('checkedLuggage', {
              context: luggageWeight ? 'withWeigth' : 'withoutWeight',
              count: flightsLuggage ? 1 : 0,
              weight: luggageWeight
            }),
            icon: _jsx(IconLuggage, {})
          }],
          linkTitle: t('baggageLinkTitle'),
          linkUrl: baggageInfoLink,
          children: t(flightsLuggage ? 'luggage.legalNotice' : 'luggage.missingLuggageNotice')
        })
      })]
    })]
  });
};